import AbstractAction from 'utils/AbstractAction'

class Action extends AbstractAction {
  _namespace = 'ShoppingRewards'
}

const fetchYodleeAccounts = new Action('fetchYodleeAccounts', {
  success: ({ providerAccounts, hasPendingProviderAccount }) => ({
    providerAccounts,
    hasPendingProviderAccount,
  }),
})

const deleteYodleeAccount = new Action('deleteYodleeAccount', {
  init: (accountId, callback) => ({ accountId, callback }),
})

const fetchShoppingRewardsStatistics = new Action('fetchShoppingRewardsStatistics', {
  init: (callback) => ({ callback }),
  success: (records) => ({ records }),
})

export default {
  fetchYodleeAccounts,
  deleteYodleeAccount,
  fetchShoppingRewardsStatistics,
}
